import React, { memo, useMemo } from 'react';
import { Text, Spacer } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import Step from './components/Step/index';
import BrowserMockCard from './components/BrowserMockCard';
import { getEmailFooterHtml } from './templates';

import './styles.scss';

const UnsubscribeSettings = memo(() => {
    const emailFooterSrc = useMemo(() => {
        const footerText = getLiteral('label_marketing_campaigns_unsubscribe_footer_text');
        const unsubscribeText = getLiteral('label_marketing_campaigns_unsubscribe_here');
        const html = getEmailFooterHtml(footerText, unsubscribeText);
        return `data:text/html;charset=utf-8,${encodeURIComponent(html)}`;
    }, []);

    return (
        <div className="unsubscribe-settings">
            <div className="unsubscribe-settings__scroll-container">
                <div className="unsubscribe-settings__header">
                    <Text type="h6" bold>
                        {getLiteral('title_marketing_campaigns_unsubscribe_preview')}
                    </Text>
                    <Spacer height="8" />
                    <Text type="body" className="unsubscribe-settings__description">
                        {getLiteral('label_marketing_campaigns_unsubscribe_preview_desc')}
                    </Text>
                </div>

                <Spacer height="32" />

                <div className="unsubscribe-settings__steps">
                    <Step
                        number={1}
                        title={getLiteral('label_marketing_campaigns_unsubscribe_step_1')}
                    >
                        <div className="unsubscribe-settings__iframe-container">
                            <iframe
                                src={emailFooterSrc}
                                className="unsubscribe-settings__iframe"
                                title="Email footer preview"
                            />
                        </div>
                    </Step>

                    <Step
                        number={2}
                        title={getLiteral('label_marketing_campaigns_unsubscribe_step_2')}
                    >
                        <BrowserMockCard>
                            <iframe
                                src={`${window.location.origin}/#/email-unsubscribed?originEmail=no-reply@example.com&originName=Example Company`}
                                className="unsubscribe-settings__iframe unsubscribe-settings__iframe--confirmation"
                                title="Unsubscribe confirmation preview"
                            />
                        </BrowserMockCard>
                    </Step>
                </div>
            </div>
        </div>
    );
});

UnsubscribeSettings.displayName = 'UnsubscribeSettings';

export default UnsubscribeSettings;
